'use client';

import React from 'react';

import { pseudoI18n } from "@/i18n/pseudoI18n";
import Button from "@/components/button";

export default function Error() {
  const { t } = pseudoI18n();

  return (
    <div className="container py-28 text-center">
      <h1 className='text-[6rem]'>500</h1>
      <p className="mb-4">{ t( 'Internal Server Error.' ) }</p>
      <Button style='link' url='/' className='border-secondary border rounded-3xl py-2 px-4 hover:no-underline m-auto'>
        { t( 'Go home' ) }
      </Button>
    </div>
  );
}
